import { Section, SectionHeader } from './Section';
import { IQuickLinksSectionEntry } from '../../../../contentful/types/IQuickLinksSectionEntry';
import { getLinkItemsForEntries } from '../../domain/use-cases/getLinkItemsForEntries';
import { useCommonData } from '../../../../common-data/useCommonData';
import { QuickLinksColumn } from '../../../../components/common/quick-links/QuickLinksColumn';
import { IQuickLinkItem } from '../../../../ui';
import renderQuickLinkItem from '../../domain/use-cases/renderQuickLinkItem';

export interface IQuickLinksSectionProps {
	section: IQuickLinksSectionEntry;
	id: string;
}

export function QuickLinksSection({ section, id }: IQuickLinksSectionProps) {
	const { pathToPageIdMap } = useCommonData();
	const items =
		section.fields.links &&
		getLinkItemsForEntries<IQuickLinkItem>(
			section.fields.links,
			pathToPageIdMap,
		);

	return (
		<Section removeTopPadding={!section.fields.title} id={id}>
			{section.fields.title && (
				<SectionHeader styling="h4">{section.fields.title}</SectionHeader>
			)}
			<QuickLinksColumn>
				{items?.map((linkItem: IQuickLinkItem) =>
					renderQuickLinkItem(linkItem),
				)}
			</QuickLinksColumn>
		</Section>
	);
}
